export const appStorePath =
  'https://itunes.apple.com/app/apple-store/id792750948?pt=34104800&ct=web-digital&mt=8';
export const appStoreStrengthPlusPath =
  'https://apps.apple.com/us/app/peloton-strength/id6476712925';
export const playStorePath =
  'https://play.google.com/store/apps/details?id=com.onepeloton.callisto&referrer=utm_source%3Donepeloton%26utm_medium%3DdigitalMarketingPage';
